import React, { FunctionComponent } from 'react';
import { PageView } from '@jg/react-tracking';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { RouteProps, withRouter, RouteComponentProps } from 'react-router';
import Loading from '@jg/loading';

import OneSearchPicker from '../../components/OneSearchPicker/OneSearchPicker';
import { appActions, appThunk, apiThunk } from '../../actions';
import { getJoinRoutes, JoinRoutes } from '../../selectors/routeSelectors';
import { getRequestIsInFlight } from '../../selectors/loadingSelectors';
import JoinStepNavigationContainer from '../JoinStepNaviagtionContainer/JoinStepNaviagtionContainer';
import { IAppState } from '../../types/state.d';

export interface ICause {
  name: string;
  id: number;
  logo: string;
  type: string;
  score: number;
  campaignGuid: string | null;
  countryCode?: string;
}

type SelectCausePageProps = RouteComponentProps<unknown> & {
  saveCause: (cause: ICause) => void;
  savedCause: ICause | null;
  pushToPage: typeof appThunk.pushToPage;
  fetchCharityData: typeof apiThunk.fetchCharityData;
  joinRoutes: JoinRoutes;
  isInFlight: boolean;
};

export const SelectCausePage: FunctionComponent<SelectCausePageProps> = ({
  saveCause,
  savedCause,
  pushToPage,
  joinRoutes,
  fetchCharityData,
  isInFlight,
}) => {
  const { t } = useTranslation();
  const continueBtnClick = async () => {
    await fetchCharityData();
    if (joinRoutes.nextStep) {
      pushToPage(joinRoutes.nextStep);
    }
  };
  return (
    <PageView
      trackingData={{
        subtype: 'join team',
        event_value: 'select cause',
        page_section: 'join team > select cause',
      }}
    >
      <Helmet title={t('title.join.selectCause')} />
      <main
        className="jg-space-pbxl jg-space-pbml@md"
        data-qa="select-cause-page"
      >
        <JoinStepNavigationContainer />
        <h1 className="jg-text--center jg-space-mbmd">
          {t('content.selectCause.heading')}
        </h1>
        <OneSearchPicker
          filterType="campaignv2,charity"
          placeholder={t('content.selectCause.placeholder')}
          label={t('content.selectCause.placeholder')}
          isLabelHidden
          onSelection={saveCause}
          selected={savedCause}
        />
        <div className="jg-tc-button-container jg-space-mtlg">
          <button
            type="button"
            disabled={!savedCause || isInFlight}
            className="jg-btn"
            onClick={continueBtnClick}
            data-qa="select-cause-continue"
          >
            {isInFlight ? (
              <Loading size="small" colour="purple" />
            ) : (
              t('global.button.continue')
            )}
          </button>
        </div>
      </main>
    </PageView>
  );
};

const mapStateToProps = (state: IAppState, ownProps: RouteProps) => ({
  savedCause: state.app.selectedCause,
  joinRoutes: getJoinRoutes(state, ownProps),
  isInFlight: Boolean(getRequestIsInFlight(state, 'GET_CHARITY_DATA')),
});

const mapDispatchToProps = {
  saveCause: appActions.saveCause,
  pushToPage: appThunk.pushToPage,
  fetchCharityData: apiThunk.fetchCharityData,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SelectCausePage),
);
